module.exports = __webpack_public_path__ + "static/media/selected_logo.80e7b662.svg";